export enum SECTIONS {
	MAIN = 'main',
	OFFER = 'offer',
	WORKSHEET = 'worksheet',
	WORKSHEET_VIEW = 'worksheet_view',
	REQUISITE = 'requisite',
}

export enum STEPS {
	ORGANIZATION = 'organization',
	DIRECTOR = 'director',
	SIGNER = 'signer',
	ADDRESS = 'address',
	SUCCESS = 'success',
}

export const STEPS_DATA = {
	[STEPS.ORGANIZATION]: {
		title: 'Сведения об организации',
		subTitle: null,
		prev: null,
		next: STEPS.DIRECTOR,
		number: 1,
	},
	[STEPS.DIRECTOR]: {
		title: 'Руководитель организации (ЕИО)',
		subTitle: null,
		prev: STEPS.ORGANIZATION,
		next: STEPS.SIGNER,
		number: 2,
	},
	[STEPS.SIGNER]: {
		title: 'Подписант',
		subTitle: 'Укажите сведения о лице, имеющего полномочия на подписание документов',
		prev: STEPS.DIRECTOR,
		next: STEPS.ADDRESS,
		number: 3,
	},
	[STEPS.ADDRESS]: {
		title: 'Адреса',
		subTitle: 'Сведения об официальных адресах организации',
		prev: STEPS.SIGNER,
		next: STEPS.SUCCESS,
		number: 4,
	},
	[STEPS.SUCCESS]: {
		title: 'Анкета организации',
		subTitle: null,
		prev: null,
		next: null,
		number: null,
	},
}

export enum KindIncorporationForm {
	LEGAL = 'legal',
	INDIVIDUAL = 'individual',
}

export enum SLUG_TAXATION {
	OSN = 'osn',
}

export enum SLUG_FREE_TAX_BASIS {
	STATE_145 = 'статья 145',
}

export enum TYPE_CONTRACT {
	PROCESSED_OFFER_LETTERS = 'processed_offer_letters',
}

export enum TYPE_DOCUMENT {
	EGRUL_EXTRACTS = 'egrul_extracts',
	EGRIP_EXTRACTS = 'egrip_extracts',
	PASSPORTS = 'passports',
	PROTOCOLS = 'protocols',
	POWER_OF_ATTORNEYS = 'power_of_attorneys',
}

export enum TYPE_MATCH_ADDRESS {
	POSTAL_LEGAL = 'postal_legal',
	ACTUAL_POSTAL = 'actual_postal',
	ACTUAL_LEGAL = 'actual_legal',
}

export enum TYPE_ADDRESS {
	LEGAL = 'legal',
	POSTAL = 'postal',
	ACTUAL = 'actual',
}

export enum STATUS_PARTNER {
	POTENTIAL = 'potential',
	FILLING_PROFILE = 'filling_profile',
	TEMP_BLOCKED = 'temp_blocked',
	SS_CHECK_AUTO = 'ss_check_auto',
}

export const KEY_OTHER = '0'

export enum KEYS_BASIC_LEGAL {
	statute = 'Устав',
	attorney = 'Доверенность',
}

export const workBasicIpOptions = [
	{
		label: 'Листа записи (если зарегистрирован с 01.01.2017 г.)',
		key: '1',
		value: 'Листа записи',
	},
	{
		label: `Свидетельства о государственной регистрации физического лица в качестве индивидуального предпринимателя
		 (если зарегистрирован с 2004 г.)`,
		key: '2',
		value:
			'Свидетельства о государственной регистрации физического лица в качестве индивидуального предпринимателя',
	},
	{
		label: `Свидетельства о внесении в Единый государственный реестр индивидуальных предпринимателей записи об 
		индивидуальном предпринимателе, зарегистрированном до 1 января 2004 г. (если зарегистрирован до 2004 г.)`,
		key: '3',
		value: `Свидетельства о внесении в Единый государственный реестр индивидуальных предпринимателей записи об 
		индивидуальном предпринимателе, зарегистрированном до 1 января 2004 г.`,
	},
	{
		label: `Другое`,
		key: KEY_OTHER,
		value: KEY_OTHER,
	},
]

export const workBasicLegalOptions = [
	{
		label: 'Устава',
		key: '1',
		value: KEYS_BASIC_LEGAL.statute,
	},
	{
		label: 'Доверенность',
		key: '2',
		value: KEYS_BASIC_LEGAL.attorney,
	},
	{
		label: `Другое`,
		key: KEY_OTHER,
		value: KEY_OTHER,
	},
]

export enum TYPE_OFFER {
	OFFER_100K = 'offer_100k',
	OFFER_10M = 'offer_10m',
	OFFER_30M = 'offer_30m',
	OFFER_150M = 'offer_150m',
	INDIVIDUAL_CONTRACT = 'individual_contract',
}

export const DEFAULT_LINK_OFFER = '/knowledge/conditions/public-offer'

export const LINK_OFFER = {
	[TYPE_OFFER.OFFER_100K]: DEFAULT_LINK_OFFER,
	[TYPE_OFFER.OFFER_10M]: DEFAULT_LINK_OFFER,
	[TYPE_OFFER.OFFER_30M]: DEFAULT_LINK_OFFER,
	[TYPE_OFFER.OFFER_150M]: '/knowledge/conditions-other/address-offer-eco',
}

export const offerOptions = [
	{
		id: TYPE_OFFER.OFFER_100K,
		name: 'Оферта 100т',
	},
	{
		id: TYPE_OFFER.OFFER_10M,
		name: 'Оферта 10млн.',
	},
	{
		id: TYPE_OFFER.OFFER_30M,
		name: 'Оферта 30млн',
	},
	{
		id: TYPE_OFFER.OFFER_150M,
		name: 'Оферта КЭС 150млн',
	},
	{
		id: TYPE_OFFER.INDIVIDUAL_CONTRACT,
		name: 'Индивидуальный договор',
	},
]

const enum MOTIVATION {
	FIXED = 'fixed',
	PERCENT = 'percent',
}

export const motivationOptions = [
	{
		id: MOTIVATION.FIXED,
		name: 'Фиксированный доход',
	},
	{
		id: MOTIVATION.PERCENT,
		name: 'Процентный доход',
	},
]
